import { render, staticRenderFns } from "./ReportingIcon.vue?vue&type=template&id=3a4a4d9b&scoped=true"
var script = {}
import style0 from "./ReportingIcon.vue?vue&type=style&index=0&id=3a4a4d9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a4d9b",
  null
  
)

export default component.exports